import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import myAxios from '../../../../lib/axios';


const initialState = {
    data: [],
    meta: null,
};

export const fetchJobs = createAsyncThunk(
    'masters/fetchJobs',
    async (query) => {
        try {
            const response = await myAxios.get(`/jobs/admin/all`, {
                params: query
            });
            
            return { success: true, message: "Jobs fetched successfully!", data: response?.data?.data, meta: response?.data?.meta };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const fetchSingleJobs = createAsyncThunk(
    'masters/fetchSingleJobs',
    async (query) => {
        try {
            const response = await myAxios.get(`/jobs/${query?.job_id}`);
            
            return { success: true, message: "Job fetched successfully!", data: response?.data?.job };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const approveJobs = createAsyncThunk(
    'masters/approveJobs',
    async (formData) => {        
        try {
            const response = await myAxios.put(`/jobs/approve`, formData);
            
            return { success: true, message: "Jobs fetched successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const bulkDeleteJobs = createAsyncThunk(
    'masters/bulkDeleteJobs',
    async (formData) => {
        try {
            const response = await myAxios.post(`/jobs/delete`, formData);
            
            return { success: true, message: "Jobs fetched successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const detailJobs = createAsyncThunk(
    'masters/detailJobs',
    async (data) => {
        try {
            const response = await myAxios.patch(`/masters/jobs/${data?.query?.jobsId}`, data?.formData);
            return { success: true, message: "Jobs updated successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const showOnHomePage = createAsyncThunk(
    'masters/showOnHomePage',
    async (data) => {
        
        try {
            const response = await myAxios.put(`/jobs/show-on-homepage/${data?.query?.jobsId}`, data?.formData);
            return { success: true, message: "Job updated successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

const jobsSlice = createSlice({
    name: 'jobs',
    initialState,
    reducers: {
        clearJobsData: state => {
            state.data = [];
        },
        setJobsData: (state, action) => {
            state.data = action.payload;
        },
        setJobsMeta: (state, action) => {
            state.meta = action.payload;
        },
       
    },
});

export const jobsReducer = jobsSlice.reducer;
export const { clearJobsData, setJobsData, setJobsMeta } = jobsSlice.actions;

export const selectJobsData = (state) => state.jobs.data;
export const selectJobsMeta = (state) => state.jobs.meta;
